import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import { Card, CardContent } from "@/components/ui/card";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BookOpen, FileText, Users } from "lucide-react";

export default function DatosGeneralesIndex() {
  const [grupos, setGrupos] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/grupos");
        setGrupos(data);
      } catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);

  return (
    <AppLayout>
      <div className="max-w-5xl">
        <div className="mb-8">
          <div className="text-xs tracking-[0.2em] uppercase text-[#9F2241] mb-2">Formato imprimible</div>
          <h1 className="text-3xl md:text-4xl font-semibold text-[#10312B] tracking-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Datos Generales de los alumnos
          </h1>
          <p className="text-sm text-[#545454] mt-2">
            Seleccione un grupo para generar el formato en tamaño oficio horizontal (una sola hoja).
          </p>
        </div>

        {grupos.length === 0 ? (
          <Card className="border-[#E5E7EB]">
            <CardContent className="p-12 text-center">
              <BookOpen className="w-10 h-10 text-[#9CA3AF] mx-auto mb-3" />
              <div className="text-[#545454]">No tiene grupos asignados. Contacte al administrador.</div>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {grupos.map((g) => (
              <Link
                key={g.id}
                to={`/grupos/${g.id}/datos-generales`}
                data-testid={`dg-grupo-${g.id}`}
                className="group"
              >
                <Card className="border-[#E5E7EB] group-hover:border-[#235B4E] transition-colors h-full">
                  <CardContent className="p-5">
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="text-xs uppercase tracking-wider text-[#9CA3AF] mb-1">
                          {g.plantel?.nivel}
                        </div>
                        <div className="text-3xl font-semibold text-[#10312B]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                          {g.grado}° {g.letra}
                        </div>
                        <div className="text-sm text-[#545454] mt-2 truncate">{g.plantel?.nombre}</div>
                      </div>
                      <FileText className="w-5 h-5 text-[#235B4E]" />
                    </div>
                    <div className="mt-4 pt-3 border-t border-[#E5E7EB] flex items-center gap-2 text-sm">
                      <Users className="w-4 h-4 text-[#235B4E]" />
                      <span className="text-[#374151]">{g.alumnos_count} alumnos</span>
                      <span className="ml-auto text-xs text-[#9CA3AF]">{g.ciclo}</span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}
